







import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import * as d3 from 'd3';

@Component({
  name: 'DpDiagram',
  components: {
  },
})
export default class DpDiagram extends Vue {
  // eslint-disable-next-line
  protected generateChart(d3: any, width: number, height: number) {
    return null;
  }

  protected mounted(): void {
    if (this.$refs.diagram) {
      this.renderChart();
    }
    window.addEventListener('resize', () => {
      if (this.$refs.diagram) {
        this.renderChart();
      }
    });
  }

  protected renderChart() {
    if (this.$refs.diagram && this.$refs.diagramContainer) {
      const { width, height } = (this.$refs.diagramContainer as any).getBoundingClientRect();
      const svg: any = this.generateChart(d3, width, height);
      const prevSvg: any = (this.$refs.diagram as any).querySelector('svg');
      if (prevSvg) {
        prevSvg.remove();
      }
      (this.$refs.diagram as any)
        .append(svg.node());
    }
  }
}
